import {useQuery} from '@tanstack/react-query';
import {lkApi} from 'api';
import {CartOrderItemSuccessInfoResponse} from 'api/dataTypes';
import {CartProductItemData} from 'modules/Cart/components/CartProductItem/CartProductItem';
import {useMemo} from 'react';
import {useParams} from 'react-router';

export function useOrderSuccess() {
    const {orderId} = useParams();

    const {data: orderSuccesInfoData, isLoading} = useQuery({
        queryKey: ['cartOrderSuccessInfo', orderId],
        queryFn: () => {
            if (orderId) {
                return lkApi.getCartOrderSuccessInfo({orderId});
            }
        },
        staleTime: Infinity,
        retry: false,
        enabled: Boolean(orderId),
    });

    const products = useMemo(() => {
        return (orderSuccesInfoData?.order_items || []).map(
            mapOrderProductToCartProduct,
        );
    }, [orderSuccesInfoData]);

    return {
        orderId,
        orderSuccesInfoData,
        products,
        isLoading,
    };
}

function mapOrderProductToCartProduct(
    product: CartOrderItemSuccessInfoResponse,
): CartProductItemData {
    return {
        id: product.id,
        title: product.name,
        link: product.url,
        article: product.marking,
        preview: product.image,
        count: product.quantity,
        price: {
            old: product.price?.old || 0,
            current: product.price?.current || 0,
        },
        counter: {
            min: 1,
            addBy: 1,
        },
    };
}
